export const PUBLIC_LISTINGS = [
  {
    id: 1,
    title: 'Skyline Loft',
    location: 'Downtown, Manchester',
    beds: 2,
    baths: 2,
    sqft: 980,
    rent: 1850,
    tag: 'Featured',
    image:
      'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=900&h=600&fit=crop&q=80',
    gallery: [
      'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=900&h=600&fit=crop&q=80',
      'https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?w=900&h=600&fit=crop&q=80',
      'https://images.unsplash.com/photo-1600566752355-35742bed6a58?w=900&h=600&fit=crop&q=80',
    ],
    description:
      'Floor-to-ceiling windows and an open-plan living space make this downtown loft feel expansive. Recently refreshed kitchen, in-unit laundry, and secure fob entry.',
    highlights: ['Balcony', 'Parking space', 'Pet-friendly', 'Furnished option'],
    availableFrom: 'Available now',
  },
  {
    id: 2,
    title: 'Harbor View Terrace',
    location: 'Waterfront District',
    beds: 3,
    baths: 2,
    sqft: 1240,
    rent: 2400,
    tag: 'New',
    image:
      'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=900&h=600&fit=crop&q=80',
    gallery: [
      'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=900&h=600&fit=crop&q=80',
      'https://images.unsplash.com/photo-1600573472592-401b489a3cdc?w=900&h=600&fit=crop&q=80',
      'https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?w=900&h=600&fit=crop&q=80',
    ],
    description:
      'Terrace views toward the water, generous bedrooms, and a separate study nook. Ideal for sharers who want space and light without sacrificing commute time.',
    highlights: ['Private terrace', 'Water views', 'Bike storage', 'EPC B'],
    availableFrom: '1 May 2026',
  },
  {
    id: 3,
    title: 'Elm Court Studios',
    location: 'Northern Quarter',
    beds: 1,
    baths: 1,
    sqft: 520,
    rent: 920,
    tag: null,
    image:
      'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=900&h=600&fit=crop&q=80',
    gallery: [
      'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=900&h=600&fit=crop&q=80',
      'https://images.unsplash.com/photo-1600566753089-00f18fb6b3ea?w=900&h=600&fit=crop&q=80',
      'https://images.unsplash.com/photo-1600585154084-4e5fe7c39198?w=900&h=600&fit=crop&q=80',
    ],
    description:
      'Compact studio with clever storage, a proper kitchen zone, and steps from cafés and transit. Perfect for solo professionals.',
    highlights: ['All bills optional package', 'High-speed fibre', 'Concierge'],
    availableFrom: 'Available now',
  },
  {
    id: 4,
    title: 'Maple Heights Duplex',
    location: 'Chorlton',
    beds: 4,
    baths: 3,
    sqft: 1680,
    rent: 2895,
    tag: 'Featured',
    image:
      'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=900&h=600&fit=crop&q=80',
    gallery: [
      'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=900&h=600&fit=crop&q=80',
      'https://images.unsplash.com/photo-1600585154363-67eb9e2e2099?w=900&h=600&fit=crop&q=80',
      'https://images.unsplash.com/photo-1600607688969-a5bfcd646d29?w=900&h=600&fit=crop&q=80',
    ],
    description:
      'Split-level living with two reception rooms, a generous garden patio, and parking for two vehicles. Suited to families or a professional house-share.',
    highlights: ['Garden', '2 parking', 'Duplex layout', 'Recently decorated'],
    availableFrom: '15 April 2026',
  },
  {
    id: 5,
    title: 'Garden Mews',
    location: 'Didsbury',
    beds: 2,
    baths: 1,
    sqft: 760,
    rent: 1320,
    tag: null,
    image:
      'https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=900&h=600&fit=crop&q=80',
    gallery: [
      'https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=900&h=600&fit=crop&q=80',
      'https://images.unsplash.com/photo-1600585152911-d8bec8a9690d?w=900&h=600&fit=crop&q=80',
      'https://images.unsplash.com/photo-1600573472550-8090b5e0745e?w=900&h=600&fit=crop&q=80',
    ],
    description:
      'Quiet mews setting with a private courtyard garden. Warm timber floors, integrated appliances, and excellent schools nearby.',
    highlights: ['Courtyard', 'Quiet street', 'Near parks'],
    availableFrom: 'Available now',
  },
  {
    id: 6,
    title: 'The Atrium',
    location: 'MediaCity',
    beds: 2,
    baths: 2,
    sqft: 1050,
    rent: 1950,
    tag: 'New',
    image:
      'https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?w=900&h=600&fit=crop&q=80',
    gallery: [
      'https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?w=900&h=600&fit=crop&q=80',
      'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=900&h=600&fit=crop&q=80',
      'https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?w=900&h=600&fit=crop&q=80',
    ],
    description:
      'Resort-style building with an internal atrium, gym access, and concierge. Corner unit with dual aspect light throughout the day.',
    highlights: ['Gym', 'Concierge', 'Corner unit', 'MediaCity walks'],
    availableFrom: 'Available now',
  },
  {
    id: 7,
    title: 'Brick Lane Townhouse',
    location: 'Ancoats',
    beds: 3,
    baths: 2,
    sqft: 1420,
    rent: 2200,
    tag: null,
    image:
      'https://images.unsplash.com/photo-1600585154529-764f991b2c3a?w=900&h=600&fit=crop&q=80',
    gallery: [
      'https://images.unsplash.com/photo-1600585154529-764f991b2c3a?w=900&h=600&fit=crop&q=80',
      'https://images.unsplash.com/photo-1600607687644-c7171b42498f?w=900&h=600&fit=crop&q=80',
      'https://images.unsplash.com/photo-1600566752355-35742bed6a58?w=900&h=600&fit=crop&q=80',
    ],
    description:
      'Exposed brick feature walls, steel staircase, and a roof terrace for summer evenings. Walking distance to the best restaurants in Ancoats.',
    highlights: ['Roof terrace', 'Exposed brick', 'Townhouse'],
    availableFrom: '1 June 2026',
  },
  {
    id: 8,
    title: 'Riverside Penthouse',
    location: 'Salford Quays',
    beds: 2,
    baths: 2,
    sqft: 1180,
    rent: 2650,
    tag: 'Featured',
    image:
      'https://images.unsplash.com/photo-1600607687644-c7171b42498f?w=900&h=600&fit=crop&q=80',
    gallery: [
      'https://images.unsplash.com/photo-1600607687644-c7171b42498f?w=900&h=600&fit=crop&q=80',
      'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=900&h=600&fit=crop&q=80',
      'https://images.unsplash.com/photo-1600573472592-401b489a3cdc?w=900&h=600&fit=crop&q=80',
    ],
    description:
      'Top-floor penthouse with wraparound glazing and uninterrupted river views. Premium finishes, walk-in wardrobe, and underground parking.',
    highlights: ['River views', 'Penthouse', 'Underground parking', 'Walk-in wardrobe'],
    availableFrom: 'Available now',
  },
];

export function getPublicListingById(id) {
  const n = Number(id);
  return PUBLIC_LISTINGS.find((p) => p.id === n) ?? null;
}
